<template>
  <div id="app">
    <router-view>
    </router-view>
  </div>
</template>

<script>
  import util from '@/libs/util'
  export default {
    name: 'app',
    watch: {
      '$i18n.locale': 'i18nHandle'
    },
    created () {
      this.i18nHandle(this.$i18n.locale)
    },
    methods: {
      i18nHandle (val, oldVal) {
        util.cookies.set('lang', val)
        document.querySelector('html').setAttribute('lang', val)
      }
    }
  }
</script>

<style lang="scss">
  @import '~@/assets/style/public-class.scss';
  /*html {*/
  /*  color: #454649;*/
  /*}*/
  .section-header {
     background-color: #ebf1f6;
     height: 40px;
     line-height: 40px;
     padding-left: 5px;
     margin: 0px 0px 5px;
     color: #111111;
   }
  .section-header-plus {
    display: flex;
    margin: 10px 0px;
    height: 40px;
    line-height: 40px;
    padding-left: 5px;
    color: #111111;
  }
  .el-form {
    .el-form-item {
      margin-bottom: 0px;
    }
  }
  .el-input {
    /*width: 150;*/
    input {
      /*background-color: ghostwhite;*/
      height: 1.5em;
      line-height: 1em;
      border-style: hidden;
      border-bottom: 1px solid black;
      outline: none;
      text-align: right;
      border-radius: 0px;
    }
  }
  .inputw220>input{
    width: 220px;
  }

  .inputw215>input{
    width: 215px;
  }
  .inputw150>input{
    width: 150px;
  }
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/App.vue"
}
</vue-filename-injector>
